<template>
  <!-- eslint-disable vue/no-parsing-error  -->
  <div>
    <div class="container">
      <div class="columns is-centered">
        <div class="b-portlet" style="width: 100%">
          <div class="b-portlet-header has-text-centered">
            <h1 class="is-size-5 has-text-weight-bold">
              {{ $t('title.onlineInternalAudit') }}
              {{ $t('title.servicePackage') }}
            </h1>
          </div>
          <div class="b-portlet-body">
            <div v-if="isCorporate" class="payment-corporate has-text-centered">
              <p v-html="$t('payment.corporateWarning')"></p>
              <div class="buttons is-centered">
                <router-link class="button is-light" :to="{ name: 'home' }">
                  {{ $t('button.cancel') }}
                </router-link>
                <button class="button is-success" @click="signUpAgain">
                  {{ $t('payment.newAccount') }}
                </button>
              </div>
            </div>
            <div v-else class="columns">
              <div class="column is-7">
                <div class="b-portlet" style="margin-bottom: 40px; padding: 20px">
                  <div class="b-portlet-header">
                    <h3 class="is-size-5 has-text-weight-bold">
                      {{ $t('title.billingInfo') }}
                    </h3>
                  </div>
                  <div class="b-portlet-body">
                    <form v-on:submit.prevent="onSubmit()">
                      <div class="field field-body">
                        <b-field
                          :type="{ 'is-danger': errors.has('firstName') }"
                          :message="errors.first('firstName')"
                        >
                          <b-input
                            icon-pack="fas"
                            icon="user"
                            :placeholder="$t('validation.attributes.firstName')"
                            v-model="billing.firstname"
                            name="firstName"
                            v-validate="'required'"
                          />
                        </b-field>
                        <b-field
                          :type="{ 'is-danger': errors.has('lastName') }"
                          :message="errors.first('lastName')"
                        >
                          <b-input
                            icon-pack="fas"
                            icon="user"
                            :placeholder="$t('validation.attributes.lastName')"
                            v-model="billing.lastname"
                            name="lastName"
                            v-validate="'required'"
                          />
                        </b-field>
                      </div>
                      <b-field>
                        <div class="block">
                          <b-radio
                            v-model="billingType"
                            name="bilingType"
                            native-value="personal"
                            @input="changeBillingType()"
                            >{{ $t('title.personal') }}</b-radio
                          >
                          <b-radio
                            v-model="billingType"
                            name="bilingType"
                            native-value="commercial"
                            @input="changeBillingType()"
                            >{{ $t('title.commercial') }}</b-radio
                          >
                        </div>
                      </b-field>
                      <b-field
                        v-if="billingType === 'personal'"
                        :type="{ 'is-danger': errors.has('identityNo') }"
                        :message="errors.first('identityNo')"
                      >
                        <b-input
                          icon-pack="fas"
                          icon="id-card"
                          :placeholder="$t('validation.attributes.identityNo')"
                          v-model="billing.identityNo"
                          name="identityNo"
                          v-validate="billingType === 'personal' ? 'required|min:11|max:11' : ''"
                        />
                      </b-field>
                      <div v-if="billingType === 'commercial'" style="padding-bottom: 15px">
                        <b-field
                          :type="{ 'is-danger': errors.has('companyName') }"
                          :message="errors.first('companyName')"
                        >
                          <b-input
                            icon-pack="fas"
                            icon="building"
                            :placeholder="$t('validation.attributes.companyName')"
                            v-model="billing.companyName"
                            name="companyName"
                            v-validate="billingType === 'commercial' ? 'required' : ''"
                          />
                        </b-field>

                        <div class="field field-body">
                          <b-field
                            :type="{ 'is-danger': errors.has('taxNo') }"
                            :message="errors.first('taxNo')"
                          >
                            <b-input
                              icon-pack="fas"
                              icon="file-invoice"
                              :placeholder="$t('validation.attributes.taxNo')"
                              v-model="billing.taxNo"
                              name="taxNo"
                              v-validate="billingType === 'commercial' ? 'required' : ''"
                            />
                          </b-field>
                          <b-field
                            :type="{
                              'is-danger': errors.has('taxAdministration')
                            }"
                            :message="errors.first('taxAdministration')"
                          >
                            <b-input
                              icon-pack="fas"
                              icon="warehouse"
                              :placeholder="$t('validation.attributes.taxAdministration')"
                              v-model="billing.taxAdministration"
                              name="taxAdministration"
                              v-validate="billingType === 'commercial' ? 'required' : ''"
                            />
                          </b-field>
                        </div>
                      </div>

                      <b-field
                        :type="{ 'is-danger': errors.has('address') }"
                        :message="errors.first('address')"
                      >
                        <b-input
                          rows="2"
                          type="textarea"
                          v-model="billing.address"
                          name="address"
                          :placeholder="$t('validation.attributes.address')"
                          v-validate="'required'"
                        ></b-input>
                      </b-field>
                      <div class="field field-body">
                        <b-field
                          :type="{ 'is-danger': errors.has('city') }"
                          :message="errors.first('city')"
                        >
                          <b-select
                            expanded
                            icon-pack="fas"
                            icon="city"
                            v-model="billing.city"
                            name="city"
                            :placeholder="$t('validation.attributes.city')"
                            v-validate="'required'"
                          >
                            <option v-for="option in cities" :value="option.name" :key="option.id">
                              {{ option.name }}
                            </option>
                          </b-select>
                        </b-field>
                        <b-field
                          :type="{ 'is-danger': errors.has('district') }"
                          :message="errors.first('district')"
                        >
                          <b-input
                            icon-pack="fas"
                            icon="building"
                            :placeholder="$t('validation.attributes.district')"
                            v-model="billing.district"
                            name="district"
                            v-validate="'required'"
                          />
                        </b-field>
                      </div>
                      <b-field
                        :type="{ 'is-danger': errors.has('gsmNumber') }"
                        :message="errors.first('gsmNumber')"
                      >
                        <b-input
                          icon-pack="fas"
                          icon="mobile-alt"
                          :placeholder="$t('validation.attributes.gsmNumber')"
                          v-model="billing.gsmNumber"
                          name="gsmNumber"
                          v-validate="'required'"
                        />
                      </b-field>
                      <b-field
                        class="field"
                        :type="{ 'is-danger': errors.has('email') }"
                        :message="errors.first('email')"
                      >
                        <b-input
                          icon-pack="fas"
                          icon="envelope"
                          :placeholder="$t('validation.attributes.email')"
                          v-model="billing.email"
                          name="email"
                          v-validate="'required|email'"
                        />
                      </b-field>
                    </form>
                  </div>
                </div>
              </div>
              <div class="column is-5">
                <div class="b-portlet">
                  <div class="b-portlet-header">
                    <h3 class="is-size-5 has-text-weight-bold">
                      {{ $t('title.amount') }}
                    </h3>
                  </div>
                  <div class="b-portlet-body">
                    <ul>
                      <li>
                        1 x {{ $t('title.onlineInternalAudit') }}
                        {{ $t('title.servicePackage') }}
                        <span class="is-pulled-right has-text-weight-bold "
                          >{{ $t('title.packageAmount') }} {{ $t('title.packageCurrency') }}
                          <span class="is-size-7">+ KDV</span></span
                        >
                      </li>
                      <li v-if="discount">
                        {{ discount.code }} (%{{ discount.value }})
                        <span class="is-pulled-right has-text-weight-bold"
                          >- {{ discount.amount }} {{ $t('title.packageCurrency') }}</span
                        >
                      </li>
                      <li v-if="discount">
                        <b>{{ $t('title.total') }}</b>
                        <span class="is-pulled-right has-text-weight-bold"
                          >{{ price }} {{ $t('title.packageCurrency') }}</span
                        >
                      </li>
                    </ul>
                    <hr class="navbar-divider" style="margin:20px 0 20px 0;" />
                    <div class="field has-addons">
                      <div class="control is-expanded">
                        <b-input
                          icon-pack="fas"
                          icon="money-check-alt"
                          :placeholder="$t('validation.attributes.discountCode')"
                          v-model="discountCode"
                          name="discountCode"
                        />
                        <span
                          v-if="invalidDiscountCode"
                          class="has-text-danger"
                          style="padding: 5px"
                          >{{ $t('description.invalidDiscountCode') }}</span
                        >
                      </div>
                      <div class="control">
                        <a class="button is-dark" @click="checkDiscount()">{{
                          $t('button.apply')
                        }}</a>
                      </div>
                    </div>
                    <hr class="navbar-divider" style="margin:20px 0 20px 0;" />
                    <b-field
                      style="padding-top: 10px"
                      :type="{ 'is-danger': errors.has('readInformationForm') }"
                      :message="errors.first('readInformationForm')"
                    >
                      <b-checkbox
                        name="readInformationForm"
                        v-validate="'required:true'"
                        v-model="readInformationForm"
                      >
                        <a @click="openPaymentInformationModal()">{{
                          $t('description.informationFormLink')
                        }}</a>
                        {{ $t('description.readAndAgree') }}.
                      </b-checkbox>
                    </b-field>
                    <b-field
                      :type="{ 'is-danger': errors.has('readSalesAgreement') }"
                      :message="errors.first('readSalesAgreement')"
                    >
                      <b-checkbox
                        name="readSalesAgreement"
                        v-validate="'required:true'"
                        v-model="readSalesAgreement"
                      >
                        <a @click="openPaymentSalesAgrementModal()">{{
                          $t('description.salesAgreementLink')
                        }}</a>
                        {{ $t('description.readAndAgree') }}.
                      </b-checkbox>
                    </b-field>
                    <article class="message is-info is-small payment-redirect">
                      <div class="message-body">
                        <p>{{ $t('payment.redirectInfo') }}</p>
                        <p>
                          <a :href="legalInformationUrl" target="_blank" rel="noopener">{{
                            $t('title.legalInformation')
                          }}</a>
                          {{ $t('payment.legalInformation') }}
                        </p>
                      </div>
                    </article>
                  </div>
                  <div class="b-portlet-footer" style="margin-bottom: 20px">
                    <div class="field is-grouped is-pulled-right">
                      <div class="control">
                        <button
                          class="button is-primary"
                          :class="{ 'is-loading': isRedirecting }"
                          :disabled="isRedirecting"
                          @click="startPayment"
                        >
                          {{ $t('button.pay') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-centered" style="padding-top: 10px">
        <img class="" src="../../assets/footer-payments.png" />
      </div>
    </div>
    <ContentFooter style="margin-top: 25px" />
  </div>
</template>
<script>
import * as Sentry from '@sentry/vue'
import { mapGetters } from 'vuex'
import ApiService from '../../_api/api.service'
import ToastService from '../../_helpers/toast.service'
import { LOGOUT } from '../../store/actions.type'
import PaymentAgreement from './PaymentAgreement.vue'
import ContentFooter from '../../layouts/dashboard/ContentFooter.vue'
import { WEBSITE_URL } from '../../_helpers/config'

// The API's answer is only followed to iyzico's own page, over https
const isIyzicoPage = url => {
  try {
    const { protocol, hostname } = new URL(url)
    return protocol === 'https:' && /(^|\.)iyzipay\.com$/.test(hostname)
  } catch (error) {
    return false
  }
}

export default {
  components: { ContentFooter },
  data () {
    return {
      billing: {},
      cities: [],
      discountCode: null,
      invalidDiscountCode: false,
      billingType: 'personal',
      packagePrice: parseFloat(this.$t('title.packageAmount')),
      price: parseFloat(this.$t('title.packageAmount')),
      readInformationForm: false,
      readSalesAgreement: false,
      discount: null,
      isRedirecting: false,
      legalInformationUrl: `${WEBSITE_URL}/yasal-bilgilendirmeler`
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    // The old pricing table's rule: a company user is asked to sign up again with
    // another e-mail instead of buying the standard package.
    isCorporate () {
      return !!this.currentUser.companyId
    }
  },
  mounted () {
    window.addEventListener('pageshow', this.onPageShow)
    this.loadSelects()
  },
  beforeDestroy () {
    window.removeEventListener('pageshow', this.onPageShow)
  },
  methods: {
    // The back button from iyzico's page can bring this page back as it was left, with the
    // button still busy
    onPageShow (event) {
      if (event.persisted) this.isRedirecting = false
    },
    // The standard package needs an individual account, opened with another e-mail.
    signUpAgain () {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.push({ name: 'signup', query: { redirect: this.$route.fullPath } })
      })
    },
    changeBillingType () {
      this.billing.identityNo = null
      this.billing.taxAdministration = null
      this.billing.companyName = null
      this.billing.taxNo = null
    },
    loadSelects () {
      ApiService.query('/select/cities').then(data => {
        this.cities = data
      })
    },
    checkDiscount () {
      ApiService.post('/discount/verify', {
        discountCode: this.discountCode
      }).then(data => {
        if (data.isValid === true) {
          this.invalidDiscountCode = false
          this.discount = {
            code: this.discountCode,
            value: data.value,
            amount: this.packagePrice * (data.value / 100)
          }
          this.price = this.packagePrice - this.discount.amount
        } else {
          this.discountCode = null
          this.invalidDiscountCode = true
          this.discount = null
          this.price = parseFloat(this.$t('title.packageAmount'))
        }
      })
    },
    // The card is entered on iyzico's page; it sends the user back to the paymentResult
    // page through the API's callback. The button stays busy until the page is left.
    startPayment () {
      this.$validator.validateAll().then(result => {
        if (!result) return
        this.isRedirecting = true
        ApiService.post('/payment/start', {
          // the applied code, as the amount and the agreements show it: not whatever is in the
          // box, which may be cleared or not applied yet
          discountCode: this.discount ? this.discount.code : null,
          invoiceInfo: this.billing,
          readInformationForm: this.readInformationForm,
          readSalesAgreement: this.readSalesAgreement
        })
          .then(({ paymentPageUrl }) => {
            if (isIyzicoPage(paymentPageUrl)) {
              window.location.assign(paymentPageUrl)
              return
            }
            // the address carries the payment's token, it is not reported
            Sentry.captureMessage('The payment page address is not iyzico\'s')
            ToastService.error(this.$t('payment.pageError'))
            this.isRedirecting = false
          })
          .catch(() => {
            // the API service has already shown the error
            this.isRedirecting = false
          })
      })
    },
    openPaymentInformationModal () {
      ApiService.post('/payment/agreement', {
        discountCode: this.discount ? this.discount.code : null,
        invoiceInfo: this.billing,
        formName: 'PaymentInformation'
      }).then(data => {
        if (data) {
          this.$buefy.modal.open({
            parent: this,
            props: { htmlContent: data, name: 'PaymentInformation' },
            component: PaymentAgreement,
            events: {
              saved: () => {
                this.readInformationForm = true
              }
            }
          })
        }
      })
    },
    openPaymentSalesAgrementModal () {
      ApiService.post('/payment/agreement', {
        discountCode: this.discount ? this.discount.code : null,
        invoiceInfo: this.billing,
        formName: 'SalesAgreement'
      }).then(data => {
        if (data) {
          this.$buefy.modal.open({
            parent: this,
            props: { htmlContent: data, name: 'SalesAgreement' },
            component: PaymentAgreement,
            events: {
              saved: () => {
                this.readSalesAgreement = true
              }
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.payment-corporate {
  padding: 2rem 1rem;
}

.payment-corporate p {
  margin-bottom: 1.5rem;
}

.payment-redirect {
  margin-top: 1.5rem;
}

.payment-redirect p + p {
  margin-top: 0.5rem;
}
</style>
